import { useNavigate } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';

import { getDraftedForms } from 'api/Forms';

export const useDraftedForms = ({ params = {}, options = {}, dependencies = [] }) => {
  const navigate = useNavigate();
  return useQuery(['form_drafts', ...dependencies], () => getDraftedForms(navigate, params), {
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    staleTime: 5000,
    ...options
  });
};
